export const handleChangeDataPageProducts = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_PRODUCTS', name, value
});